import React from 'react';
import { Link } from 'umi';
import { Result, Button } from 'antd';
import { trackButtonClick } from '@/utils/trackEvent';

const Unauthorized = (
  <Result
    status="403"
    title="403"
    subTitle="Sorry, you are not authorized to access this page."
    extra={
      <Button
        id="unauthorized-home"
        type="primary"
        onClick={() => trackButtonClick('unauthorized-home')}
      >
        <Link to="/">Home</Link>
      </Button>
    }
  />
);

export default Unauthorized;
